module.exports = __webpack_public_path__ + "public/images/step-2.16350c87f1a4d0e2774e16550117f2f3.png";